import React from 'react';
import PropTypes from 'prop-types';

/**
 * StatCard component for displaying a single statistic
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - Title of the statistic
 * @param {string|number} props.value - Value to display
 * @param {string} [props.icon] - Optional icon to display
 * @param {React.ReactNode} [props.footer] - Optional footer content
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} Rendered component
 */
const StatCard = ({
  title,
  value,
  icon,
  footer,
  className = ''
}) => {
  return (
    <div className={`p-3 bg-gray-100 rounded-lg ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {icon && <span className="mr-2 text-lg">{icon}</span>}
          <h3 className="text-sm font-medium text-gray-700">{title}</h3>
        </div>
        <p className="text-lg font-semibold text-gray-900">{value}</p>
      </div>
      {footer && (
        <div className="mt-2">
          {footer}
        </div>
      )}
    </div>
  );
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.string,
  footer: PropTypes.node,
  className: PropTypes.string
};

export default StatCard; 